import type { Locale } from "@/lib/i18n";
import { pl, type CBrowserPressOnlineTranslations } from "./pl";
import { en } from "./en";
import { de } from "./de";

export const cBrowserPressOnlineTranslations: Record<
  Locale,
  CBrowserPressOnlineTranslations
> = {
  pl,
  en,
  de,
};

export type { CBrowserPressOnlineTranslations };
